import { useFormikContext } from "formik";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Input from "../common/form/Input";

export interface IFormData {
  file: string;
  name: string;
}

interface IProps {
  file: File | null;
}

const AssistanceDocumentAddContent: FC<IProps> = ({ file }) => {
  const { t } = useTranslation();

  const { errors, touched, resetForm, setFieldValue } =
    useFormikContext<IFormData>();

  useEffect(() => {
    resetForm();
    setFieldValue("file", file?.name ?? "");
    setFieldValue("name", file?.name ?? "");
  }, [file, resetForm, setFieldValue]);

  return (
    <>
      <Input
        name="file"
        label={t("document.addDocument.file")}
        disabled={true}
      />
      <Input
        name="name"
        label={t("document.addDocument.name")}
        error={touched.name && !!errors.name}
        maxLength={255}
      />
    </>
  );
};

export default AssistanceDocumentAddContent;
